import React from "react";
import SimpleWhiteButton from "./buttons/SimpleWhiteButton";

const Pricing = () => {
  return (
    <div
      className="w-full flex flex-col items-center justify-center px-4 sm:px-10 font-figtree pt-12 pb-20
                bg-gradient-to-b from-[#2B63C8] via-[#163670] to-[#000000]"
    >
      <p
        className="text-3xl sm:text-4xl md:text-[48px] font-bold text-center inline-block
          bg-gradient-to-r from-[#85FFF1] via-[#5CFEFF] to-[#DCEBFF]
          text-transparent bg-clip-text !leading-tight"
      >
        Start Free. Hire Smarter.
      </p>
      <p
        className="text-3xl sm:text-4xl md:text-[48px] font-bold text-center
          bg-gradient-to-r from-[#85FFF1] via-[#5CFEFF] to-[#DCEBFF]
          text-transparent bg-clip-text !leading-tight"
      >
        Shortlist top 3 candidates in 48 hours.
      </p>
      <p className="text-sm sm:text-base font-medium text-white leading-6 sm:leading-7 text-center mt-4">
        Imagine meeting just 3 people  and confidently hiring 1.
        <br />
        No resumes. No bottlenecks. Just results.
      </p>
      <div className="mt-4 sm:mt-8 mb-8 sm:mb-12">
        <div className="flex justify-center items-center p-1 rounded-[28px] bg-white/10 border  border-white/20">
          <div className="bg-[#fff] text-black text-base font-semibold py-1 px-3 md:py-3 md:px-3 border border-[#9B8AFB] rounded-[24px]">
            Monthly Billed
          </div>
        </div>
      </div>
      <div className="overflow-x-auto w-full max-w-fit">
        <table className="min-w-full border-collapse">
          <thead>
            <tr className="border border-[#62626261]">
              <th className="px-3 py-3 md:pl-4 border-r border-[#62626261] text-left"></th>
              <th className="px-3 py-3 md:pl-4 border-r border-[#62626261] text-left">
                <div className="flex flex-col justify-between">
                  <p className="text-sm sm:text-base font-bold text-white">
                    Quick Start
                  </p>
                  <p
                    className="text-3xl sm:text-4xl font-semibold inline-block
                        bg-gradient-to-b from-[#66FEFC] to-[#0474FF]
                        text-transparent bg-clip-text"
                  >
                    Free
                  </p>
                </div>
              </th>
              <th className="px-3 py-3 md:pl-4 border-r border-[#62626261] text-left">
                <div className="flex flex-col justify-between">
                  <div className="flex justify-between items-center">
                    <p className="text-sm sm:text-base font-bold text-white uppercase">
                      Starter
                    </p>
                    <div
                      className="flex items-center justify-center text-xs sm:text-sm text-[#363F72] rounded-2xl px-2 py-0.5 sm:px-3 sm:py-1
                                    bg-gradient-to-r from-[#3B82FF] to-[#fff]"
                    >
                      Popular
                    </div>
                  </div>
                  <div className="flex items-center">
                    <p className="text-white text-base sm:text-[20px] font-semibold">
                      ₹
                    </p>
                    <p
                      className="text-3xl sm:text-4xl font-semibold inline-block
                        bg-gradient-to-b from-[#66FEFC] to-[#0474FF]
                        text-transparent bg-clip-text"
                    >
                      13,200
                    </p>
                    <p className="text-white text-base sm:text-[20px] font-semibold">
                      {" "}
                      /mo
                    </p>
                  </div>
                </div>
              </th>
              <th className="px-3 py-3 md:pl-4 border-r border-[#62626261] text-left">
                <div className="flex flex-col justify-between">
                  <p className="text-sm sm:text-base font-bold text-white">
                    Pro
                  </p>
                  <div className="flex items-center">
                    <p className="text-white text-base sm:text-[20px] font-semibold">
                      ₹
                    </p>
                    <p
                      className="text-3xl sm:text-4xl font-semibold inline-block
                        bg-gradient-to-b from-[#66FEFC] to-[#0474FF]
                        text-transparent bg-clip-text"
                    >
                      27,000
                    </p>
                    <p className="text-white text-base sm:text-[20px] font-semibold">
                      {" "}
                      /mo
                    </p>
                  </div>
                </div>
              </th>
              <th className="px-3 py-3 md:pl-4 text-left">
                <div className="flex flex-col justify-between">
                  <p className="text-sm sm:text-base font-bold text-white">
                    Enterprise
                  </p>
                  <p
                    className="text-xl sm:text-2xl md:text-[24px] font-semibold inline-block
                        bg-gradient-to-b from-[#66FEFC] to-[#0474FF]
                        text-transparent bg-clip-text"
                  >
                    Custom Pricing
                  </p>
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="text-white text-sm sm:text-base font-semibold text-left">
            <tr className="border border-t-0 border-[#62626261]">
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                Ideal For
              </td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                Solo founders,
                <br />
                Hiring Consultants
              </td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                Small teams, early
                <br /> growth
              </td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                Growth stage, SMEs
              </td>
              <td className="px-3 py-3 md:pl-4">Enterprise hiring<br/>teams</td>
            </tr>
            <tr className="border border-t-0 border-[#62626261]">
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                Job Posts
              </td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">1</td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">5</td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">15</td>
              <td className="px-3 py-3 md:pl-4">Unlimited</td>
            </tr>
            <tr className="border border-t-0 border-[#62626261]">
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                Interviews
              </td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                10/month
              </td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                10 Free + 50/month
              </td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                50 Free + 100/month
              </td>
              <td className="px-3 py-3 md:pl-4">Custom</td>
            </tr>
            <tr className="border border-t-0 border-[#62626261]">
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">Users</td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">1</td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">2</td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">Up to 5</td>
              <td className="px-3 py-3 md:pl-4">Unlimited</td>
            </tr>
            <tr className="border border-t-0 border-[#62626261]">
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                Video Retention
              </td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">30 days</td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">90 days</td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                180 days
              </td>
              <td className="px-3 py-3 md:pl-4">Custom</td>
            </tr>
            <tr className="border border-t-0 border-[#62626261]">
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                WhatsApp Integration
              </td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">Yes</td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">Yes</td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">Yes</td>
              <td className="px-3 py-3 md:pl-4">Yes</td>
            </tr>
            <tr className="border border-t-0 border-[#62626261]">
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                Email Integration
              </td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">Yes</td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">Yes</td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">Yes</td>
              <td className="px-3 py-3 md:pl-4">Yes</td>
            </tr>
            <tr className="border border-t-0 border-[#62626261]">
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">Support</td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">Email</td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                Email + Call
              </td>
              <td className="px-3 py-3 md:pl-4 border-r border-[#62626261]">
                Email + Call <br /> Priority Support
              </td>
              <td className="px-3 py-3 md:pl-4">Dedicated Manager</td>
            </tr>
            <tr>
              <td className="px-3 py-3 md:pl-4"></td>
              <td className="px-3 py-3 md:pl-4">
                <div className="flex justify-center">
                  <SimpleWhiteButton to="/checkout" text="Try free now" />
                </div>
              </td>
              <td className="px-3 py-3 md:pl-4">
                <div className="flex justify-center">
                  <SimpleWhiteButton to="/checkout" text="Start Free Plan" />
                </div>
              </td>
              <td className="px-3 py-3 md:pl-4">
                <div className="flex justify-center">
                  <SimpleWhiteButton to="/checkout" text="Start Free Plan" />
                </div>
              </td>
              <td className="px-3 py-3 md:pl-4">
                <div className="flex justify-center">
                  <SimpleWhiteButton to="/demo" text="Get a demo" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Pricing;
